import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgCompanyIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2Zm-8 18H5v-5.586l3-3 3 3V20Zm8 0h-6v-4a1 1 0 0 0 .707-1.707L9 9.586V4h10v16Z"
      fill="currentColor"
    />
    <path
      d="M11 6h2v2h-2V6Zm4 0h2v2h-2V6Zm0 4.031h2V12h-2v-1.969ZM15 14h2v2h-2v-2Zm-8 1h2v2H7v-2Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCompanyIcon);
export default ForwardRef;
